import { type ReactNode, createContext, use } from 'react';

const ShellHeaderContext = createContext<ReactNode>(null);

export function ShellHeaderProvider({
  header,
  children,
}: {
  readonly header: ReactNode;
  readonly children: ReactNode;
}): ReactNode {
  return <ShellHeaderContext value={header}>{children}</ShellHeaderContext>;
}

export function ShellHeader(): ReactNode {
  return use(ShellHeaderContext);
}
